import { render, staticRenderFns } from "./BranchFeeReview.vue?vue&type=template&id=ae476f14&"
import script from "./BranchFeeReview.vue?vue&type=script&lang=js&"
export * from "./BranchFeeReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports